import { render, staticRenderFns } from "./LpAdmBtn.vue?vue&type=template&id=230039da&scoped=true"
import script from "./LpAdmBtn.vue?vue&type=script&lang=js"
export * from "./LpAdmBtn.vue?vue&type=script&lang=js"
import style0 from "./LpAdmBtn.vue?vue&type=style&index=0&id=230039da&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230039da",
  null
  
)

export default component.exports